
import { lang } from './en/lang';
import { dataSource } from './en/dataSource';
import { common } from './en/common';
import { login } from './en/login';
import { register } from './en/register';
import { pinLogin } from './en/pinLogin';
import { pos } from './en/pos';
import { receipt } from './en/receipt';
import { backOffice } from './en/backOffice';
import { modals } from './en/modals';
import { platform } from './en/platform';
import { errors } from './en/errors';

export const translations = {
  lang,
  dataSource,
  common,
  login,
  register,
  pinLogin,
  pos,
  receipt,
  backOffice,
  modals,
  platform,
  errors
};
